import React, { useEffect, useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Text from "./text"
import Space from "./space"
import Divider from "./divider"
import Link from "./link"
import { StaticImage } from "gatsby-plugin-image"

type Props = {
  url: string
  title: string
}

const SocialShare: React.FC<Props> = ({ url, title }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            siteUrl
          }
        }
      }
    `
  )

  const shareTitle = title || site.siteMetadata.title
  const shareURL = url
    ? url.startsWith("http")
      ? url
      : `${site.siteMetadata.siteUrl}${url}`
    : site.siteMetadata.siteUrl

  return (
    <div className="flex items-center justify-center space-x-5">
      <Link
        href={`https://twitter.com/share?url=${shareURL}&text=${shareTitle}`}
      >
        <StaticImage
          src="../images/share/x.png"
          alt="ペアケアのTwitterアカウント"
          placeholder="none"
          width={38}
        />
      </Link>
      <Link href={`https://www.facebook.com/share.php?u=${shareURL}`}>
        <StaticImage
          src="../images/share/facebook.png"
          alt="ペアケアのFacebookアカウント"
          placeholder="none"
          width={38}
        />
      </Link>
      <Link href={`https://line.me/R/share?text=${shareURL}`}>
        <StaticImage
          src="../images/share/line.png"
          alt="ペアケアのLINEアカウント"
          placeholder="none"
          width={38}
        />
      </Link>
    </div>
  )
}

export default SocialShare
